import { Grid, Typography } from "@mui/material";
import styles from "../ServicesMenu/services.module.scss";

const YoungadultOverview = () => {
  return (
    <div className={styles.youngadultOverview}>
      <Grid className={styles.cardContainer}>
        <Grid>
          <Typography className={styles.heading}>Overview</Typography>

          <Grid>
            <Typography className={styles.summary}>
              The Hindu Community and Cultural Center introduced{" "}
              <span style={{color:"#000",fontWeight:"700",fontSize:"18px" }}>Young Adults Committee</span> aimed at meeting the needs of
              individuals aged 18-32 within our community. This initiative is
              designed to assist young adults in achieving their social and
              career objectives, while also providing exposure to Hindu religion
              and culture through periodic Q&A sessions and volunteer
              opportunities. The objective is to foster self-confidence, promote
              success in both careers and relationships, navigate cross-cultural
              dynamics within our communities, lead fulfilling lives, and
              contribute positively to the community.
            </Typography>
          </Grid>
          <Typography className={styles.heading}>Mission Statement</Typography>
          <Typography className={styles.summary}>
            Young Adult Program Interest Form <br />
            Ages: 18-32 Years <br />
            Build the next-generation platform of young adults shaped by the
            Hindu Community and Cultural Center's heritage and values while
            advancing interests in career counseling, professional networking,
            and mental and spiritual well-being. <br />
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSftPGiibGtisNzQ8KrmE-5Q5DFrIrpGWtKbCbQ_eIm_IkoUXQ/viewform?usp=sf_link" target="_blank" style={{color:"#f05802"}}>HCCC Young Adults Program Interest Form</a>
           
          </Typography>
        </Grid>
        <Grid>
          <Typography className={styles.heading}>Young Adults Team</Typography>
        </Grid>

        <Typography className={styles.header}>
          Dimple Cyril - Executive Committee Chairperson
        </Typography>
        <Typography className={styles.header}><a href="mailto:ec_young_adults@livermoretemple.org">ec_young_adults@livermoretemple.org</a></Typography>
        <br />
      </Grid>
    </div>
  );
};
export default YoungadultOverview;
